import { Link } from "react-router-dom";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

const stats = [
  { value: "2 Mio.+", label: "Objekt-Mindestwert CHF" },
  { value: "48 h", label: "Lieferzeit für das Branding-Konzept" },
  { value: "100%", label: "Eigene Domain pro Objekt" },
  { value: "15+", label: "Ausgezeichnete Branding-Projekte" },
];

export default function QuoteSection() {
  const { ref: statsRef, isVisible: statsVisible } = useScrollReveal(0.15);
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <>
      {/* Stats */}
      <section className="py-24 px-8 lg:px-16 bg-white border-y border-light-gray">
        <div className="max-w-screen-xl mx-auto">
          <div
            ref={statsRef}
            className="grid grid-cols-2 lg:grid-cols-4 gap-12"
          >
            {stats.map((stat, i) => (
              <div
                key={stat.label}
                className={`text-center transition-all duration-800 ${
                  statsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                }`}
                style={{ transitionDelay: `${i * 120}ms` }}
              >
                <div className="font-serif text-4xl lg:text-5xl text-text-primary font-medium mb-3">
                  {stat.value}
                </div>
                <p className="text-xs tracking-luxury font-sans text-text-muted uppercase leading-relaxed">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quote / CTA */}
      <section className="py-40 px-8 lg:px-16 relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/a2cd106b6896867f6c8740ec8dc8af5e.jpg"
            alt="Luxuriöses Wohnzimmer mit Alpenpanorama"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-white/88" />
        </div>

        <div
          ref={ref}
          className={`relative z-10 max-w-3xl mx-auto text-center transition-all duration-800 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <p className="section-label mb-8 text-gold">Schweizer Präzision</p>
          <blockquote className="font-serif text-3xl md:text-4xl lg:text-5xl text-text-primary leading-tight italic mb-10">
            „Ein außergewöhnliches Objekt verdient mehr als ein Inserat. Es verdient eine Bühne."
          </blockquote>
          <span className="gold-divider mb-10" />
          <p className="font-sans font-light text-text-secondary text-base leading-relaxed mb-12 max-w-xl mx-auto">
            Lassen Sie uns gemeinsam eine digitale Erfahrung erschaffen, die Ihr Objekt unvergesslich macht — und den Verkaufsprozess fundamental verändert.
          </p>
          <Link to="/kontakt" className="btn-gold-fill">
            Jetzt Anfrage stellen
          </Link>
        </div>
      </section>
    </>
  );
}
